import { defineComponent as _defineComponent } from 'vue'
import AuthButton from './ExternalAuthButton.vue';
import { computed, onMounted, ref, watch } from 'vue';
import { CreateOauthAccountRequest } from 'JS/types/Account';
import { IExternalAuthHandler, useExternalAuth } from 'JS/composables/external-auth';
import { IJoinRewardsStep, IVerifyUserData, SessionMAccountLookupCode } from 'JS/types/rewards';
import { useServices } from '../../composables/services';
import { useViewportWidth } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalAuthLogin',
  props: {
    skipCartMerge: { type: Boolean },
    isCreateAccount: { type: Boolean },
    isVerifyAccount: { type: Boolean }
  },
  emits: ["error", "loading", "go-to-rewards-with-oauth", "signed-in", "go-to-enter-phone"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'error', message: string): void
	(e: 'loading', loading: boolean): void
	(e: 'go-to-rewards-with-oauth', page: IJoinRewardsStep, data?: IVerifyUserData, createOauthAccountRequest?: CreateOauthAccountRequest): void;
	(e: 'signed-in'): void
	(e: 'go-to-enter-phone', createOauthAccountRequest: CreateOauthAccountRequest )
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	skipCartMerge: boolean,
	isCreateAccount?: boolean,
	isVerifyAccount?: boolean
}

const googleSignin = ref(null);
const { accountService } = useServices();





const viewportWidth = useViewportWidth();

const googleButtonOptions = computed((): google.accounts.id.GsiButtonConfiguration => {
	const padding = viewportWidth.value > 768 ?  20 : 30;
	const width = Math.min(Math.max(viewportWidth.value, 200) - padding, 400);
	return {
		type: 'standard',
		theme: 'outline',
		size: 'large',
		shape: 'rectangular',
		width,
		logo_alignment: 'left',
		text: props.isCreateAccount ? 'continue_with' : 'signin_with'
	};
});

const handleAuthenticate = (handler: IExternalAuthHandler) =>
	props.isVerifyAccount ? handler.verify() : handler.login();

const {
	apple,
	facebook,
	googleInit,
	error,
	result,
	loading,
	createOauthAccountRequest,
	newAccountError,
} = useExternalAuth(
	accountService,
	props.skipCartMerge ?? false,
	{
		parent: googleSignin,
		options: googleButtonOptions.value
	}
);

watch(error, () => {
	if (error.value) {
		emit('error', error.value);
	}
});

watch(loading, (oldVal, newVal) => {
	if (oldVal != newVal) {
		emit('loading', loading.value);
	}
});

watch(result, () => {
	if (result.value.success) {
		emit('signed-in');
	}
});

watch(newAccountError, () => {

	switch (newAccountError.value.reasonCode) {
		case SessionMAccountLookupCode.REWARDS_ACCOUNT_NOT_FOUND:
			emit('go-to-enter-phone', createOauthAccountRequest.value);
			break;
		case SessionMAccountLookupCode.REWARDS_ACCOUNT_ALREADY_LINKED:
	 		emit("error", "<span class='bold'>This email is already associated with another users rewards account. Call Customer Service at <a class='black' href='tel:+1-800-210-2370'>1-800-210-2370</a> for assistance.</span>");
			break;
		case SessionMAccountLookupCode.REWARDS_ACCOUNT_ALREADY_EXISTS:
			emit('go-to-rewards-with-oauth',
				'verification-join',
				{ phone: newAccountError.value.phone, email: newAccountError.value.email, variant: 'verification-join', redactedData: newAccountError.value.redactedData },
				createOauthAccountRequest.value,
			);
			break;
		case SessionMAccountLookupCode.SESSION_M_ERROR:
			emit("error", `Something went wrong. Please try again later.`);
		default:
			emit("error", error.value);
	}

});

watch(googleButtonOptions, options => {
	googleInit({
		parent: googleSignin,
		options
	}, props.isVerifyAccount);
});

onMounted(() => {
	googleInit({
		parent: googleSignin,
		options: googleButtonOptions.value,
	}, props.isVerifyAccount);
});


return { __sfc: true,googleSignin, accountService, props, emit, viewportWidth, googleButtonOptions, handleAuthenticate, apple, facebook, googleInit, error, result, loading, createOauthAccountRequest, newAccountError, AuthButton }
}

})